import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BASE}/api` });

export const adminApi = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

adminApi.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  const url = cfg?.url || "";
  if (error.response?.status === 401 && !cfg._retry && !url.startsWith("/auth/")) {
    cfg._retry = true;
    try {
      await adminApi.post("/auth/refresh");
      return adminApi(cfg);
    } catch {
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
});

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${BASE}${u}` : u);

export const errorMessage = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return "Merci de vérifier les champs : " + d.map((x) => x.loc?.slice(-1)[0]).join(", ");
  return typeof d === "string" ? d : "Une erreur est survenue, merci de réessayer dans un instant ou de nous appeler au +687 29 70 00.";
};
